import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import axios from 'axios';
import Slider from 'react-slick';
import { getTopPersonalizationInfo } from '../../../util/getTopPersonalizationInfo';
import * as pkg from 'react-lazy-load-image-component';
const { LazyLoadImage } = pkg;

class ArrowLeftButton extends Component {
  render() {
    return (
      <>
        {this.props.vertical == true ? (
          <div className='arrows-wrap-top'>
            <button
              onClick={this.props.onClick}
              className={`prev-top ${this.props.className}`}
              type='button'
              data-role='none'
            >
              <span className='sr-only'>Previous</span>
            </button>
            <button
              onClick={this.props.onClick}
              className={`prev-bottom ${this.props.className}`}
              type='button'
              data-role='none'
            >
              <span className='sr-only'>Previous</span>
            </button>
          </div>
        ) : (
          <button onClick={this.props.onClick} className={this.props.className} type='button' data-role='none'>
            <span className='sr-only'>Previous</span>
          </button>
        )}
      </>
    );
  }
}

class ArrowRightButton extends Component {
  render() {
    return (
      <>
        {this.props.vertical == true ? (
          <div className='arrows-wrap-bottom'>
            <button
              onClick={this.props.onClick}
              className={`next-top ${this.props.className}`}
              type='button'
              data-role='none'
            >
              <span className='sr-only'>Next</span>
            </button>
            <button
              onClick={this.props.onClick}
              className={`next-bottom ${this.props.className}`}
              type='button'
              data-role='none'
            >
              <span className='sr-only'>Next</span>
            </button>
          </div>
        ) : (
          <button onClick={this.props.onClick} className={this.props.className} type='button' data-role='none'>
            <span className='sr-only'>Next</span>
          </button>
        )}
      </>
    );
  }
}

class ProductRecs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zone: '',
      rec_attributes: [],
      target_header_txt: '',
      priceNumber: '',
      siteFormat: this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '',
      portrait: false,
      landscape: false,
      atbReady: false,
    };
    this.setRecState = this.setRecState.bind(this);
    this.showRecs = this.showRecs.bind(this);
  }

  setRecState(
    rec_product_ids,
    zone,
    symbolic,
    target_id,
    target_category,
    rec_attributes,
    target_attributes,
    target_header_txt,
    ab_test_id,
    rec_category_ids
  ) {
    this.addCollectionToFrontOfRecs(rec_attributes);
    this.addOSSToFrontOfRecs(rec_attributes);
    let showABTestRecs = this.needSaleRecsABTest();

    if (rec_attributes && rec_attributes.length > 0) {
      for (let i = 0; i < rec_attributes.length; i++) {
        const x = rec_attributes[i][2].split('/');
        rec_attributes[i][2] = x[x.length - 1].split('.jpg').join('');
      }
      this.setState({
        zone: zone,
        rec_attributes: rec_attributes,
        target_header_txt: target_header_txt,
      });
      if (this.props.gotRecs) {
        this.props.gotRecs();
        this.setState({
          atbReady: true,
        });
      }
    } else {
      if (this.props.noRecs) {
        this.props.noRecs();
      }
    }
  }
  //Leaving below method here for local testing purposes
  setOptiRecs() {
    window.optiSmartRecs = [
      {
        widget: 'PDPZ1',
        alias: '',
        position: 'productPageWidget',
        recs: [
          {
            prices: {
              USD: {
                unitPrice: 55,
                salePrice: 55,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/515958326',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/00000000_zi_a80a5324-1953-4664-8fac-1cfcb61023e2.jpg',
            attributes: {
              review_number: '4.75000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '53',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818302,
            title: 'Gold Label Roundtree  Yorke Slim Fit Non-Iron Point Collar Solid Dress Shirt',
            refCode: '20344114',
          },
          {
            prices: {
              USD: {
                unitPrice: 55,
                salePrice: 55,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-fitted-non-iron-point-collar-solid-dress-shirt/515988874',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-fitted-non-iron-point-collar-solid-dress-shirt/00000000_zi_b84a847a-1f9e-4434-9bd2-9f20a32ffc4f.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '8',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818352,
            title: 'Gold Label Roundtree  Yorke Non-Iron Fitted Point Collar Dress Shirt',
            refCode: '20344788',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-fitted-point-collar-striped-dress-shirt/515958319',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-fitted-point-collar-striped-dress-shirt/00000000_zi_03fde757-f7e1-471b-a8ca-a1e88fbcb9d5.jpg',
            attributes: {
              review_number: '4.78000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '9',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818402,
            title: 'Gold Label Roundtree  Yorke Fitted Non-Iron Point Collar Striped Dress Shirt',
            refCode: '20344029',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-fitted--non-iron-point-collar-houndstooth-checked-dress-shirt/516318258',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-fitted--non-iron-point-collar-houndstooth-checked-dress-shirt/00000000_zi_129c092c-e7b5-4d20-adcf-4c48dc800be7.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '1',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818452,
            title: 'Gold Label Roundtree  Yorke Fitted  Non-Iron Point Collar Houndstooth Checked Dress Shirt',
            refCode: '20344871',
          },
          {
            prices: {
              USD: {
                unitPrice: 55,
                salePrice: 55,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/515958323',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/00000001_zi_b36a0564-bdb1-4c2d-8714-7a19ff048062.jpg',
            attributes: {
              review_number: '4.94000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '17',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '171',
              on_sale: 'false',
            },
            id: 295860818502,
            title: 'Gold Label Roundtree  Yorke Slim Fit Non-Iron Point Collar French Cuff Solid Dress Shirt',
            refCode: '20344100',
          },
          {
            prices: {
              USD: {
                unitPrice: 55,
                salePrice: 55,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-full-fit-non-iron-point-collar-solid-dress-shirt/515988865',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-full-fit-non-iron-point-collar-solid-dress-shirt/00000000_zi_2e94c2b2-a213-4f47-ada9-59164d49b0f8.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '7',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '111',
              on_sale: 'false',
            },
            id: 295860818552,
            title: 'Gold Label Roundtree  Yorke Full-Fit Non-Iron Point Collar Solid Dress Shirt',
            refCode: '20344862',
          },
          {
            prices: {
              USD: {
                unitPrice: 49,
                salePrice: 49,
              },
            },
            url: 'https://www.dillards.com/p/roundtree--yorke-gold-label-non-iron-fitted-point-collar-short-sleeve-dress-shirt/515958320',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-gold-label-non-iron-fitted-point-collar-short-sleeve-dress-shirt/00000000_zi_0fa89bd4-b828-44b3-84c6-62b16bad1104.jpg',
            attributes: {
              review_number: '4.44000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '9',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'cheap',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '122',
              on_sale: 'false',
            },
            id: 295860818602,
            title: 'Gold Label Roundtree  Yorke Non-Iron Fitted Point Collar Short-Sleeve Solid Dress Shirt',
            refCode: '20344047',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-striped-dress-shirt/515958324',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-striped-dress-shirt/00000001_zi_8d41a90e-bf94-4ebf-b4ec-835750c4cb38.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '7',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818652,
            title: 'Gold Label Roundtree  Yorke Slim Fit Non-Iron Point Collar Striped Dress Shirt',
            refCode: '20344128',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke--full-fit-non-iron-point-collar-striped-dress-shirt/517601818',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke--full-fit-non-iron-point-collar-striped-dress-shirt/20343993_zi_1f1646c0-a3ac-4571-aec0-111e0c4ead08.jpg',
            attributes: {
              review_number: '4.70000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '10',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818702,
            title: 'Gold Label Roundtree  Yorke  Full-Fit Non-Iron Point-Collar Striped Dress Shirt',
            refCode: '20343993',
          },
          {
            prices: {
              USD: {
                unitPrice: 49,
                salePrice: 49,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/515975272',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-solid-dress-shirt/00000000_zi_cb1b9af9-a1a0-4943-87ad-c4739c3f2b12.jpg',
            attributes: {
              review_number: '3.20000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '5',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'cheap',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '122',
              on_sale: 'false',
            },
            id: 295860818752,
            title: 'Gold Label Roundtree  Yorke Slim-Fit Non-Iron Short Sleeve Point Collar Dress Shirt',
            refCode: '20344133',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-houndstooth-checked-dress-shirt/516318266',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke-non-iron-slim-fit-point-collar-houndstooth-checked-dress-shirt/00000000_zi_d19d5fd5-e018-44ce-a2a7-0ce7bd17cb33.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '1',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818802,
            title: 'Gold Label Roundtree  Yorke Non-Iron Slim Fit Point Collar Houndstooth Checked Dress Shirt',
            refCode: '20344880',
          },
          {
            prices: {
              USD: {
                unitPrice: 69,
                salePrice: 69,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke--full-fit-non-iron-point-collar-houndstooth-checked-dress-shirt/516318265',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke--full-fit-non-iron-point-collar-houndstooth-checked-dress-shirt/00000000_zi_3d398e6a-eee4-46a8-a19f-18882d7ba0bd.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '2',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818852,
            title: 'Gold Label Roundtree  Yorke  Full-Fit Non-Iron Point Collar Houndstooth Checked Dress Shirt',
            refCode: '20344876',
          },
          {
            prices: {
              USD: {
                unitPrice: 49,
                salePrice: 49,
              },
            },
            url: 'https://www.dillards.com/p/roundtree--yorke-gold-label-non-iron-short-sleeve-solid-dress-shirt/515958315',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/roundtree--yorke-gold-label-non-iron-short-sleeve-solid-dress-shirt/00000000_zi_ed8a6873-042e-415a-9ada-c75018696894.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '12',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'cheap',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '122',
              on_sale: 'false',
            },
            id: 295860818902,
            title:
              'Roundtree  Yorke Gold Label Roundtree  Yorke Full-Fit Non-Iron Point Collar Short Sleeve Solid Dress Shirt',
            refCode: '20343998',
          },
          {
            prices: {
              USD: {
                unitPrice: 55,
                salePrice: 55,
              },
            },
            url: 'https://www.dillards.com/p/gold-label-roundtree--yorke--slim-fit-non-iron-point-collar-solid-dress-shirt/515988882',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/gold-label-roundtree--yorke--slim-fit-non-iron-point-collar-solid-dress-shirt/00000000_zi_720ac63e-b730-4252-8844-9b0b26232b1a.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '2',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0515',
              brand: 'roundtree & yorke',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860818952,
            title: 'Gold Label Roundtree  Yorke Non Iron Slim Fit Point Collar Dress Shirt',
            refCode: '20344830',
          },
          {
            prices: {
              USD: {
                unitPrice: 59,
                salePrice: 59,
              },
            },
            url: 'https://www.dillards.com/p/murano-slim-fit-point-collar-solid-sateen-dress-shirt/509125304',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/murano-slim-fit-point-collar-solid-sateen-dress-shirt/05721967_zi_lavender.jpg',
            attributes: {
              review_number: '4.90000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '253',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0514',
              brand: 'murano',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '221',
              on_sale: 'false',
            },
            id: 295860819002,
            title: 'Murano Slim-Fit Point Collar Solid Sateen Dress Shirt',
            refCode: '05721967',
          },
          {
            prices: {
              USD: {
                unitPrice: 59,
                salePrice: 59,
              },
            },
            url: 'https://www.dillards.com/p/murano-slim-fit-non-iron-point-collar-solid-sateen-dress-shirt/517885775',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/murano-slim-fit-non-iron-point-collar-solid-sateen-dress-shirt/00000000_zi_c4ec0a98-e116-419d-8a0a-7e5dc1e1984e.jpg',
            attributes: {
              review_number: '4.82000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '11',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0514',
              brand: 'murano',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '221',
              on_sale: 'false',
            },
            id: 295860819052,
            title: 'Murano Slim Fit Non Iron Point Collar Solid Sateen Dress Shirt',
            refCode: '20449602',
          },
          {
            prices: {
              USD: {
                unitPrice: 69.5,
                salePrice: 69.5,
              },
            },
            url: 'https://www.dillards.com/p/cremieux-classic-fit-non-iron-point-collar-barrel-cuff-solid-pinpoint-dress-shirt/517885799',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-classic-fit-non-iron-point-collar-barrel-cuff-solid-pinpoint-dress-shirt/00000000_zi_d4a874ed-ab94-457d-91ee-8720f77c3a59.jpg',
            attributes: {
              review_number: '5.00000',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '7',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0517',
              brand: 'cremieux',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860819102,
            title: 'Cremieux Classic Fit Non-Iron Point Collar Solid Pinpoint Dress Shirt',
            refCode: '20449581',
          },
          {
            prices: {
              USD: {
                unitPrice: 69.5,
                salePrice: 69.5,
              },
            },
            url: 'https://www.dillards.com/p/cremieux-slim-fit-non-iron-point-collar-mitered-cuff-solid-pinpoint-dress-shirt/517885793',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/cremieux-slim-fit-non-iron-point-collar-mitered-cuff-solid-pinpoint-dress-shirt/00000000_zi_14156abb-b5d8-499a-82c4-6d4a5088f254.jpg',
            attributes: {
              review_number: '0.0',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '0',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0517',
              brand: 'cremieux',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '121',
              on_sale: 'false',
            },
            id: 295860819152,
            title: 'Cremieux Slim Fit Non-Iron Point Collar Mitered Cuff Solid Pinpoint Dress Shirt',
            refCode: '20449586',
          },
          {
            prices: {
              USD: {
                unitPrice: 65,
                salePrice: 65,
              },
            },
            url: 'https://www.dillards.com/p/tre-vero-classic-fit-non-iron-spread-collar-mitered-cuff-poplin-tuxedo-dress-shirt/516652222',
            img: 'https://dimg.dillards.com/is/image/DillardsZoom/mainProduct/tre-vero-classic-fit-non-iron-spread-collar-mitered-cuff-poplin-tuxedo-dress-shirt/00000000_zi_eda93626-42d4-4158-8ed4-e39527394f2d.jpg',
            attributes: {
              review_number: '0.0',
              not_contains_girls: 'true',
              term: 'dress',
              reviewrating: '0',
              decade: '051x',
              century: '05xx',
              new_arrival: 'false',
              dept: '0511',
              brand: 'tre vero',
              contains_dress: 'true',
              pricerange: 'average',
              primary_category: 'men',
              can_ship_international: 'true',
              discount: null,
              product_class: '511',
              on_sale: 'false',
            },
            id: 295860819202,
            title: 'Tre Vero Classic Fit Non-Iron Point Collar Mitered Cuff Poplin Tuxedo Dress Shirt',
            refCode: '20378418',
          },
        ],
      },
    ];
  }

  addOSSToFrontOfRecs(rec_attributes) {
    if (this.props.currentOSSAccessories && this.props.currentOSSAccessories.length > 0) {
      for (var i = this.props.currentOSSAccessories.length - 1; i >= 0; i--) {
        var accessory = this.props.currentOSSAccessories[i];
        var attributes = [
          accessory.dil_oss_acc_name,
          `/p/${accessory.dil_oss_acc_keyword}/${accessory.dil_oss_acc_catentry_id}`,
          `http://dimg.dillards.com/is/image/DillardsZoom/${accessory.dil_oss_acc_fullImage}`,
          0.0, //average rating
          '', //brand code
          '', //number reviews
          '', //minPrice
          '', //maxPrice
          'true', //shipInternational
          accessory.dil_oss_acc_catentry_id,
          accessory.dil_oss_acc_dept,
          accessory.dil_oss_acc_mic,
          (accessory.dil_oss_acc_mfname || '').split('&amp;').join('&'),
          accessory.dil_oss_acc_keyword,
        ];
        rec_attributes.unshift(attributes);
      }
    }
  }
  addCollectionToFrontOfRecs(rec_attributes) {
    if (this.props.currentCollection && this.props.currentCollection.length > 0) {
      for (var i = this.props.currentCollection.length - 1; i >= 0; i--) {
        var accessory = this.props.currentCollection[i];
        var attributes = [
          accessory.name, //name
          `/p/${accessory.keyword}/${accessory.catentryId}`, //URL
          accessory.imageName,
          0.0, //average rating
          '', //brand code
          '', //number reviews
          '', //minPrice
          '', //maxPrice
          'true', //shipInternational
          accessory.catentryId, //catentryId
          accessory.dept,
          accessory.mic,
          accessory.brandName,
          accessory.keyword,
        ];
        rec_attributes.unshift(attributes);
      }
    }
  }
  imgSourceFromAttr(thisAttr) {
    return `https://dimg.dillards.com/is/image/DillardsZoom/${this.props.passedAppFunctions.siteFormat == 'mobile' ? 'nav2' : 'productRec'}/${thisAttr[13]}/${
      thisAttr[2].split('dimg').length > -1
        ? thisAttr[2].split('/')[thisAttr[2].split('/').length - 1].split('.jpg').join('')
        : thisAttr[2]
    }.jpg`;
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.contentData && this.props.contentData.productId != nextProps.contentData.productId) {
      return true;
    }
    if (!_.isEqual(nextState, this.state)) {
      return true;
    }
    return false;
  }

  render() {
    var zoneNameMap = {
      PDPZ1: {
        title: 'you may also like',
        arrowsNum: 4,
      },

      PDPZ2: {
        title: 'Recently Viewed',
        arrowsNum: 6,
      },
      PDPZ3: {
        title: 'you may also like',
        arrowsNum: 4,
      },
      JFYZ1: {
        title: 'Just For You',
        arrowsNum: 6,
      },
      ACMZ1: {
        title: 'you may also like',
        arrowsNum: 3,
      },
      Fallback: {
        title: 'you may also like',
        arrowsNum: 4,
      },
    };
    var zoneNameInfo = zoneNameMap[this.props.zoneName] || zoneNameMap['Fallback'],
      arrows = zoneNameInfo.arrowsNum < this.state.rec_attributes.length,
      vertical = this.props.vertical || false;

    if (this.state.siteFormat == 'tablet') {
      switch (this.props.zoneName) {
        case 'PDPZ1':
        case 'PDPZ3':
          if (
            this.state.portrait ||
            this.props.contentData.productLayout == 'BundleDisplay' ||
            this.props.contentData.productLayout == 'OutfitDisplay'
          ) {
            arrows = false;
            vertical = false;
          } else {
            vertical = true;
          }
          break;
        case 'PDPZ2':
          arrows = false;
          break;
        default:
          break;
      }
    }

    let slidesToShow = this.props.slidesToShow || 4;
    if (this.state.siteFormat == 'tablet') {
      let slidesToShow = 4;
      slidesToShow += 0.5;
    }

    var settings = {
      dots: false,
      infinite: false,
      vertical: vertical,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      swipe: true,
      swipeToSlide: true,
      lazyLoad: true,
      arrows: arrows,
      prevArrow: <ArrowLeftButton vertical={vertical} />,
      nextArrow: <ArrowRightButton vertical={vertical} />,
      zoneName: this.props.zoneName,
      responsive: this.props.passedAppFunctions
        ? (this.state.siteFormat == 'tablet' &&
            this.props.passedAppFunctions.modalInfo &&
            this.props.passedAppFunctions.modalInfo.modalType == 'AddtoCartModal') ||
          (this.state.siteFormat == 'tablet' &&
            this.props.passedAppFunctions.modalInfo &&
            this.props.passedAppFunctions.modalInfo.modalType == 'InventoryModal')
          ? [
              {
                breakpoint: 1367,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  vertical: vertical,
                  arrows: false,
                },
              },
            ]
          : this.state.siteFormat == 'tablet' && this.props.addToBagModal == 'false'
            ? [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 4.5,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    vertical: vertical,
                    arrows: arrows,
                  },
                },
              ]
            : ''
        : '',
    };

    var settingsStayVertical = {
      dots: false,
      infinite: false,
      vertical: vertical || false,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      swipe: true,
      lazyLoad: true,
      arrows: zoneNameInfo.arrowsNum < this.state.rec_attributes.length,
      zoneName: this.props.zoneName,
    };

    slidesToShow = 2.5;

    var mobileSettings = {
      infinite: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 2,
      vertical: false,
      arrows: 2 < this.state.rec_attributes.length,
    };

    if (this.props.passedAppFunctions.wasParms.useProductRecommendations !== 'true') return null;

    return (
      <>
        {this.props.stayVertical &&
        this.state.siteFormat != 'mobile' &&
        this.state.siteFormat == 'tablet' &&
        !this.props.contentData.productLayout == 'BundleDisplay' &&
        !this.props.contentData.productLayout == 'OutfitDisplay' ? (
          //Not Responsive
          <aside className={`productRecs mx-auto ${settingsStayVertical.arrows ? 'has-arrows' : ''}`}>
            {this.state.target_headers_txt && this.state.target_header_txt.length ? (
              <span className='pr-title'>{this.state.target_header_txt}</span>
            ) : (
              ''
            )}
            {this.state.rec_attributes ? (
              <div>
                {
                  zoneNameInfo.title == 'you may also like' ? (
                    <h6 className='productRecs__title'>you may also like</h6>
                  ) : zoneNameInfo.title == 'Recently Viewed' ? (
                    <h6 className='recentlyViewed'>
                      <span className='recently-viewed-title'>Recently Viewed</span>
                    </h6>
                  ) : zoneNameInfo.title == 'Just For You' ? (
                    <h6 className='justForYou'>
                      <span className='recently-viewed-title'>Just For You</span>
                    </h6>
                  ) : (
                    ''
                  ) //  blank if no title specified in zoneNameMap object
                }
                {this.state.siteFormat == 'desktop' ? (
                  <Slider {...settingsStayVertical}>
                    {this.state.rec_attributes.map((attr, index) => (
                      <figure className='item' key={attr[2] + index}>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                        >
                          <LazyLoadImage src={this.imgSourceFromAttr(attr)} alt={attr[0].split('&trade;').join('™')} />
                        </Link>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                          className='item-title'
                        >
                          {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                        </Link>
                      </figure>
                    ))}
                  </Slider>
                ) : (
                  <div>
                    {this.state.rec_attributes.map((attr, index) => (
                      <figure className='item' key={attr[2] + index}>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                        >
                          <LazyLoadImage src={this.imgSourceFromAttr(attr)} alt={attr[0].split('&trade;').join('™')} />
                        </Link>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                          className='item-title'
                        >
                          {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                        </Link>
                      </figure>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              ''
            )}
          </aside>
        ) : !this.props.stayVertical && this.state.siteFormat != 'mobile' ? (
          //Responsive
          <aside className={`productRecs mx-auto ${settings.arrows ? 'has-arrows' : ''}`}>
            {this.state.target_headers_txt && this.state.target_header_txt.length ? (
              <span className='pr-title'>{this.state.target_header_txt}</span>
            ) : (
              ''
            )}
            {this.state.rec_attributes && this.state.rec_attributes.length > 3 ? (
              <div>
                {
                  zoneNameInfo.title == 'you may also like' ? (
                    <h6 className='productRecs__title'>you may also like</h6>
                  ) : zoneNameInfo.title == 'Recently Viewed' ? (
                    <h6 className='recentlyViewed'>
                      <span className='recently-viewed-title'>Recently Viewed</span>
                    </h6>
                  ) : zoneNameInfo.title == 'Just For You' ? (
                    <h6 className='justForYou'>
                      <span className='recently-viewed-title'>Just For You</span>
                    </h6>
                  ) : (
                    ''
                  ) //  blank if no title specified in zoneNameMap object
                }

                {/* ATB recs in a vertical css scroller */}
                {this.state.rec_attributes &&
                this.state.rec_attributes.length &&
                (document.querySelectorAll('.AddtoCartModal').length > 0 ||
                  document.querySelectorAll('.InventoryModal').length > 0) ? (
                  this.state.rec_attributes && this.state.rec_attributes.length ? (
                    <div id='scrollingAtbRecs'>
                      {this.state.rec_attributes.map((attr, index) => (
                        <figure className='item' key={attr[2] + index}>
                          <Link
                            to={{
                              pathname: attr[1],
                              state: {
                                qv:
                                  attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                  attr[0].toLowerCase().indexOf('egift') == -1,
                                categoryId: this.props.zoneName,
                              },
                            }}
                            onClick={() => Peerius?.smartRecsClick(attr[14])}
                          >
                            <LazyLoadImage
                              src={this.imgSourceFromAttr(attr)}
                              alt={attr[0].split('&trade;').join('™')}
                            />
                          </Link>
                          <Link
                            to={{
                              pathname: attr[1],
                              state: {
                                qv:
                                  attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                  attr[0].toLowerCase().indexOf('egift') == -1,
                                categoryId: this.props.zoneName,
                              },
                            }}
                            onClick={() => Peerius?.smartRecsClick(attr[14])}
                            className='item-title'
                          >
                            {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                          </Link>
                        </figure>
                      ))}
                    </div>
                  ) : (
                    ''
                  )
                ) : (
                  <Slider {...settings}>
                    {this.state.rec_attributes && this.state.rec_attributes.length
                      ? this.state.rec_attributes.map((attr, index) => (
                          // WWW-21733 On Sale Product Pages Test Sales Recs vs Non Sale onClick Event
                          <figure className='item' key={attr[2] + index} onClick={this.setABInteraction}>
                            <Link
                              to={{
                                pathname: attr[1],
                                state: {
                                  qv:
                                    attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                    attr[0].toLowerCase().indexOf('egift') == -1,
                                  categoryId: this.props.zoneName,
                                },
                              }}
                              onClick={() => Peerius?.smartRecsClick(attr[14])}
                            >
                              <LazyLoadImage
                                src={this.imgSourceFromAttr(attr)}
                                alt={attr[0].split('&trade;').join('™')}
                              />
                            </Link>
                            <Link
                              to={{
                                pathname: attr[1],
                                state: {
                                  qv:
                                    attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                    attr[0].toLowerCase().indexOf('egift') == -1,
                                  categoryId: this.props.zoneName,
                                },
                              }}
                              onClick={() => Peerius?.smartRecsClick(attr[14])}
                              className='item-title'
                            >
                              {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                            </Link>
                          </figure>
                        ))
                      : ''}
                  </Slider>
                )}
              </div>
            ) : this.state.rec_attributes && this.state.rec_attributes.length <= 3 ? (
              <div>
                {this.state.rec_attributes && this.state.rec_attributes.length ? (
                  zoneNameInfo.title == 'you may also like' ? (
                    <h6 className='productRecs__title'>you may also like</h6>
                  ) : zoneNameInfo.title == 'Recently Viewed' ? (
                    <h2 className='recentlyViewed'>
                      <span className='recently-viewed-title'>Recently Viewed</span>
                    </h2>
                  ) : zoneNameInfo.title == 'Just For You' ? (
                    <h2 className='justForYou'>
                      <span className='recently-viewed-title'>Just For You</span>
                    </h2>
                  ) : (
                    ''
                  ) //  blank if no title specified in zoneNameMap object
                ) : (
                  ''
                )}

                {this.state.rec_attributes && this.state.rec_attributes.length ? (
                  <Slider {...settings}>
                    {this.state.rec_attributes.map((attr, index) => (
                      <figure className='item' key={attr[2] + index}>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                        >
                          <LazyLoadImage src={this.imgSourceFromAttr(attr)} alt={attr[0].split('&trade;').join('™')} />
                        </Link>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                          className='item-title'
                        >
                          {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                        </Link>
                      </figure>
                    ))}
                  </Slider>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
          </aside>
        ) : this.state.siteFormat == 'mobile' ? (
          //For Mobile
          <aside className={`productRecs ${mobileSettings.arrows ? 'has-arrows' : ''}`}>
            {this.state.target_headers_txt && this.state.target_header_txt.length ? (
              <span className='pr-title'>{this.state.target_header_txt}</span>
            ) : (
              ''
            )}
            {this.state.rec_attributes && this.state.rec_attributes.length > 2 && this.state.siteFormat == 'mobile' ? (
              <div>
                {
                  zoneNameInfo.title == 'you may also like' ? (
                    <h6 className='productRecs__title'>you may also like</h6>
                  ) : zoneNameInfo.title == 'Recently Viewed' ? (
                    <h6 className='recentlyViewed'>
                      <span className='recently-viewed-title'>Recently Viewed</span>
                    </h6>
                  ) : zoneNameInfo.title == 'Just For You' ? (
                    <h6 className='justForYou'>
                      <span className='recently-viewed-title'>Just For You</span>
                    </h6>
                  ) : (
                    ''
                  ) //  blank if no title specified in zoneNameMap object
                }

                {/* ATB product recs in a vertical scroller */}
                {this.state.rec_attributes &&
                this.state.rec_attributes.length &&
                (document.querySelectorAll('.AddtoCartModal').length > 0 ||
                  document.querySelectorAll('.InventoryModal').length > 0) ? (
                  this.state.rec_attributes && this.state.rec_attributes.length ? (
                    <div id='scrollingAtbRecs'>
                      {this.state.rec_attributes.map((attr, index) => (
                        <figure className='item' key={attr[2] + index}>
                          <Link
                            to={{
                              pathname: attr[1],
                              state: {
                                qv:
                                  attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                  attr[0].toLowerCase().indexOf('egift') == -1,
                                categoryId: this.props.zoneName,
                              },
                            }}
                            onClick={() => Peerius?.smartRecsClick(attr[14])}
                          >
                            <LazyLoadImage
                              src={this.imgSourceFromAttr(attr)}
                              alt={attr[0].split('&trade;').join('™')}
                            />
                          </Link>
                          <Link
                            to={{
                              pathname: attr[1],
                              state: {
                                qv:
                                  attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                  attr[0].toLowerCase().indexOf('egift') == -1,
                                categoryId: this.props.zoneName,
                              },
                            }}
                            onClick={() => Peerius?.smartRecsClick(attr[14])}
                            className='item-title'
                          >
                            {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                          </Link>
                        </figure>
                      ))}
                    </div>
                  ) : (
                    ''
                  )
                ) : (
                  <Slider {...mobileSettings}>
                    {this.state.rec_attributes && this.state.rec_attributes.length
                      ? this.state.rec_attributes.map((attr, index) => (
                          <figure className='item' key={attr[2] + index}>
                            <Link
                              to={{
                                pathname: attr[1],
                                state: {
                                  qv:
                                    attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                    attr[0].toLowerCase().indexOf('egift') == -1,
                                  categoryId: this.props.zoneName,
                                },
                              }}
                              onClick={() => Peerius?.smartRecsClick(attr[14])}
                            >
                              <LazyLoadImage
                                src={this.imgSourceFromAttr(attr)}
                                alt={attr[0].split('&trade;').join('™')}
                              />
                            </Link>
                            <Link
                              to={{
                                pathname: attr[1],
                                state: {
                                  qv:
                                    attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                    attr[0].toLowerCase().indexOf('egift') == -1,
                                  categoryId: this.props.zoneName,
                                },
                              }}
                              onClick={() => Peerius?.smartRecsClick(attr[14])}
                              className='item-title'
                            >
                              {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                            </Link>
                          </figure>
                        ))
                      : ''}
                  </Slider>
                )}
              </div>
            ) : this.state.rec_attributes &&
              this.state.rec_attributes.length < 3 &&
              this.state.siteFormat == 'mobile' ? (
              <div>
                {this.state.rec_attributes && this.state.rec_attributes.length ? (
                  zoneNameInfo.title == 'you may also like' ? (
                    <h6 className='productRecs__title'>you may also like</h6>
                  ) : zoneNameInfo.title == 'Recently Viewed' ? (
                    <h6 className='recentlyViewed'>
                      <span className='recently-viewed-title'>Recently Viewed</span>
                    </h6>
                  ) : zoneNameInfo.title == 'Just For You' ? (
                    <h6 className='justForYou'>
                      <span className='recently-viewed-title'>Just For You</span>
                    </h6>
                  ) : (
                    ''
                  ) //  blank if no title specified in zoneNameMap object
                ) : (
                  ''
                )}

                {this.state.rec_attributes && this.state.rec_attributes.length
                  ? this.state.rec_attributes.map((attr, index) => (
                      <figure className='item' key={attr[2] + index}>
                        <Link
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                        >
                          <LazyLoadImage src={this.imgSourceFromAttr(attr)} alt={attr[0].split('&trade;').join('™')} />
                        </Link>
                        <Link
                          key={attr[2] + index}
                          to={{
                            pathname: attr[1],
                            state: {
                              qv:
                                attr[0].toLowerCase().indexOf('chanel') == -1 &&
                                attr[0].toLowerCase().indexOf('egift') == -1,
                              categoryId: this.props.zoneName,
                            },
                          }}
                          onClick={() => Peerius?.smartRecsClick(attr[14])}
                          className='item-title'
                        >
                          {attr[12].split('&trade;').join('™').split('#double;').join('"')}
                        </Link>
                      </figure>
                    ))
                  : ''}
              </div>
            ) : (
              ''
            )}
          </aside>
        ) : (
          ''
        )}
      </>
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.contentData && this.props.contentData.productId != nextProps.contentData.productId) {
      this.setState({
        zone: '',
        rec_attributes: '',
        target_header_txt: '',
        priceNumber: '',
      });
      this.setRecRequestData(this.generateBundlePartnumbers(nextProps) || nextProps.contentData.partNumber);
    }
  }

  setOrientationState_iOS = () => {
    var portrait = false,
      landscape = false;
    if (window.innerHeight > window.innerWidth) portrait = true;
    else landscape = true;
    this.setState({
      portrait: portrait,
      landscape: landscape,
    });
  };

  setOrientationState_chrome = () => {
    var portrait = false,
      landscape = false;
    if ($(window).width() < $(window).height()) portrait = true;
    else landscape = true;
    this.setState({
      portrait: portrait,
      landscape: landscape,
    });
  };

  componentDidMount() {
    $(window).on('showRecs', this.showRecs);
    this.setRecRequestData();
    if (this.state.siteFormat == 'tablet') {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      if (navigator.userAgent.match('CriOS')) {
        this.setOrientationState_chrome();
        this.chromeResizeHandler = _.debounce(this.setOrientationState_chrome.bind(this), 500);
        window.addEventListener('resize', this.chromeResizeHandler);
      } else {
        this.setOrientationState_iOS();
        this.iosResizeHandler = _.debounce(this.setOrientationState_iOS.bind(this), 500);
        window.addEventListener('resize', this.iosResizeHandler);
      }
    }
  }

  generateBundlePartnumbers(passedProps) {
    var returnString = '';
    var propsToUse = passedProps || this.props;
    if (
      propsToUse.contentData &&
      (propsToUse.contentData.productLayout == 'BundleDisplay' ||
        propsToUse.contentData.productLayout == 'BundleDisplay')
    ) {
      for (var i = 0; i < propsToUse.contentData.components.length; i++) {
        if (returnString.length > 0) returnString += '|';
        returnString += propsToUse.contentData.components[i].partNumber;
      }
    }
    return returnString;
  }

  showRecs() {
    //triggered from adobe launch rule
    this.formatRecContent(this.props.zoneName ? this.props.zoneName : '');
  }

  setRecRequestData(nextPartNumber) {
    let zone = this.props.zoneName ? this.props.zoneName : '';

    if (
      this.props.passedAppFunctions.wasParms.useProductRecommendations == 'true' &&
      this.props.passedAppFunctions.wasParms.adobeRecsOffByZone.indexOf(zone) == -1
    ) {
      try {
        var partNumber =
          nextPartNumber ||
          this.generateBundlePartnumbers() ||
          this.props.partNumber ||
          (this.props.contentData && this.props.contentData.partNumber);
        partNumber = partNumber != '' ? partNumber : null;
        var pageUrl = window.location.href.split('?')[0];
        var topPersonalizationInfo = getTopPersonalizationInfo('ALL', this.props.passedAppFunctions.wasParms);
        var recData = this.getRecData();
        //setting all rec data into a window scoped variable for adobe sdk migration
        window.recCallData = window.recCallData ? window.recCallData : [];
        if (recCallData.length > 0) {
          if (recCallData[0].url != pageUrl) {
            window.recCallData = [];
            recCallData.push({ url: pageUrl });
          }
        } else {
          recCallData.push({ url: pageUrl });
        }

        // var potentialCategoryId = '';
        // try{
        // 	potentialCategoryId = this.props.passedAppFunctions.getDataLayerInfo().productListItems[0]._additionalVars.primaryCategoryId;
        // }catch(e){
        // 	console.log(e);
        // }

        var thisData = {};
        thisData.zone = zone;
        thisData.category = this.props.passedAppFunctions.getURLParamValue('categoryId')
          ? this.props.passedAppFunctions.getURLParamValue('categoryId')
          : this.props.passedAppFunctions.linkToState && this.props.passedAppFunctions.linkToState.categoryId
            ? this.props.passedAppFunctions.linkToState.categoryId
            : '-10035';
        thisData.brand = recData && recData.brand ? recData.brand : '';
        thisData.partNumber = partNumber && partNumber.indexOf('|') > -1 ? partNumber.split('|')[0] : partNumber;
        thisData.url = pageUrl;
        thisData.productClass = recData && recData.productClass ? recData.productClass : '';
        thisData.mic = recData && recData.mic ? recData.mic : '';
        thisData.dept = recData && recData.dept ? recData.dept : '';
        thisData.decade = recData && recData.decade ? recData.decade : '';
        thisData.century = recData && recData.century ? recData.century : '';
        thisData.group = recData && recData.group ? recData.group : '';
        thisData.name = recData && recData.name ? recData.name : '';
        thisData.newArrival = recData && recData.newArrival ? recData.newArrival : '';
        thisData.favoriteBrand =
          topPersonalizationInfo && topPersonalizationInfo.favoriteBrand ? topPersonalizationInfo.favoriteBrand : '';
        thisData.favoriteCategoryId =
          topPersonalizationInfo && topPersonalizationInfo.favoriteSuperCat
            ? topPersonalizationInfo.favoriteSuperCat
            : '';
        thisData.includeWithRecData = true;
        recCallData.push({ ProductRecs: thisData });
      } catch (e) {
        if (
          this.props.passedAppFunctions.wasParms.adobeRecsDebug &&
          this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true'
        )
          console.log(e);
      }
    }
    if (
      !(
        this.props.contentData &&
        this.props.contentData.productLayout &&
        this.props.contentData.productLayout == 'ProductDisplay'
      )
    ) {
      try {
        $(document).trigger('addToCart');
      } catch (e) {}
    }
  }

  needSaleRecsABTest() {
    // WWW-21733 On Sale Product Pages Test Sales Recs vs Non Sale
    let needSalesRecs = false;
    const allSaleSkus = this.props.contentData?.skus?.every((value) => value.onSpecial > 0);
    if (
      (this.props.contentData?.salePage || allSaleSkus) &&
      this.props.passedAppFunctions.getFeatureFlagVariation('salePDPvsNonSaleRecs') === 'expb'
    ) {
      needSalesRecs = true;
    }
    return needSalesRecs;
  }

  formatRecContent(zone) {
    try {
      if (window.location.host === 'localhost') this.setOptiRecs();

      if (window.optiSmartRecs) {
        for (var i = 0; i < window.optiSmartRecs.length; i++) {
          var thisContent = window.optiSmartRecs[i];
          if (thisContent.widget === zone) {
            // var recInteractionData = {};
            // if(thisContent &&
            //    thisContent.rawData &&
            //    thisContent.rawData.id &&
            //    thisContent.rawData.scope &&
            //    thisContent.rawData.scopeDetails){
            // 		recInteractionData.recId = thisContent.rawData.id;
            // 		recInteractionData.recZone = thisContent.rawData.scope;
            // 		recInteractionData.recScopeDetails = thisContent.rawData.scopeDetails;
            // }
            var responseData = thisContent;
            var rec_attributes = [];
            var recRequestIds = [];
            // if(this.props.passedAppFunctions.wasParms.adobeRecsDebug && this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true') console.log(responseData.recommendedItems);

            for (var key in responseData.recs) {
              var thisRec = responseData.recs[key];
              var attrs = [
                thisRec.title,
                thisRec.url.indexOf('dillards.com') > -1 ? thisRec.url.split('dillards.com')[1] : '',
                thisRec.img.indexOf('/') > -1
                  ? thisRec.img.split('/')[thisRec.img.split('/').length - 1].split('.jpg').join('')
                  : '',
                thisRec.reviewRating ? thisRec.reviewRating : 0.0,
                '', //brand code
                thisRec.reviewNumber ? thisRec.reviewNumber : '',
                '', //minPrice
                thisRec.prices.USD.unitPrice ? thisRec.prices.USD.unitPrice : '',
                'true', //shipInternational
                thisRec.url.indexOf('/') > -1 ? thisRec.url.split('/')[thisRec.url.split('/').length - 1] : '',
                thisRec.dpt ? thisRec.dpt : '',
                thisRec.mic ? thisRec.mic : '',
                thisRec.attributes.brand
                  ? thisRec.attributes.brand
                      .split(' ')
                      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                      .join(' ')
                  : '',
                thisRec.url.indexOf('dillards.com') > -1 ? thisRec.url.split('/')[4] : '',
                thisRec.id ? thisRec.id : '',
              ];
              if (
                attrs[0].indexOf('$entity') == -1 &&
                attrs[1].length > 0 &&
                attrs[2].length > 0 &&
                attrs[9].length > 0 &&
                attrs[12].length > 0 &&
                attrs[13].length > 0
              ) {
                rec_attributes.push(attrs);
                recRequestIds.push(thisRec.id);
              }
            }
            this.setRecState(
              'rec_product_ids',
              zone,
              'symbolic',
              'target_id',
              'target_category',
              rec_attributes,
              'target_attributes',
              'target_header_txt',
              'ab_test_id',
              'rec_category_ids'
            );
            responseData.recs.splice(i, 1);
          }
        }
        if (recRequestIds) {
          const listOfIds = 'ids=' + recRequestIds.join(',');
          const optiEnv = window.location.host === 'www.dillards.com' ? 'dillardprod' : 'dillardprep';
          Peerius?.sendAjax(optiEnv + '/rec/shown.pagex?' + listOfIds);
        }
      }
    } catch (er) {
      if (
        this.props.passedAppFunctions.wasParms.adobeRecsDebug &&
        this.props.passedAppFunctions.wasParms.adobeRecsDebug == 'true'
      )
        console.log(er);
    }
  }

  getRecData() {
    var recData = {};

    if (
      this.props.passedAppFunctions &&
      this.props.passedAppFunctions.modalInfo &&
      Object.keys(this.props.passedAppFunctions.modalInfo).length > 0
    ) {
      if (
        this.props.passedAppFunctions.modalInfo.recJSON &&
        this.props.passedAppFunctions.modalInfo.recJSON.promotedDetails
      ) {
        var thisRec = this.props.passedAppFunctions.modalInfo.recJSON.promotedDetails[0];
        recData.brand = thisRec.brand ? thisRec.brand : '';
        recData.productClass = thisRec.productClass ? thisRec.productClass : '';
        recData.mic = thisRec.mic ? thisRec.mic : '';
        recData.dept = thisRec.dept ? thisRec.dept : '';
        recData.decade = thisRec.dept ? thisRec.dept.slice(0, thisRec.dept.length - 1) + 'X' : '';
        recData.century = thisRec.dept ? thisRec.dept.slice(0, thisRec.dept.length - 2) + 'XX' : '';
        recData.group = thisRec.group ? thisRec.group : '';
        recData.name = thisRec.name ? thisRec.name : '';
        recData.newArrival = thisRec.newArrival ? thisRec.newArrival : '';
      }
    } else if (this.props.contentData) {
      recData.brand = this.props.contentData.brandNameForTitle ? this.props.contentData.brandNameForTitle : '';
      recData.productClass = this.props.contentData.dceProductClass ? this.props.contentData.dceProductClass : '';
      recData.mic = this.props.contentData.mic ? this.props.contentData.mic : '';
      recData.dept = this.props.contentData.dept ? this.props.contentData.dept : '';
      recData.decade = this.props.contentData.dept
        ? this.props.contentData.dept.slice(0, this.props.contentData.dept.length - 1) + 'X'
        : '';
      recData.century = this.props.contentData.dept
        ? this.props.contentData.dept.slice(0, this.props.contentData.dept.length - 2) + 'XX'
        : '';
      recData.group = this.props.contentData.dceGroup ? this.props.contentData.dceGroup : '';
      recData.name = this.props.contentData.productName ? this.props.contentData.productName : '';
      recData.newArrival = this.props.contentData.newArrival ? this.props.contentData.newArrival : '';
    }
    return recData;
  }

  componentWillUnmount() {
    //just to clean up logs and noop function calls.
    window[`${this.props.zoneName}_zp`] = function () {};
    $(window).off('showRecs', this.showRecs);
    if (this.chromeResizeHandler) {
      window.removeEventListener('resize', this.chromeResizeHandler);
      this.chromeResizeHandler.cancel();
    }
    if (this.iosResizeHandler) {
      window.removeEventListener('resize', this.iosResizeHandler);
      this.iosResizeHandler.cancel();
    }
  }
}

export { ArrowLeftButton, ArrowRightButton, ProductRecs };
